'use client';

/**
 * The owner's way into and out of a card's editor on the storefront: Edit
 * at rest, Cancel and Save while open.
 */
export function EditButton({
  onClick,
  disabled = false,
  label = 'Edit',
}: {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="mm-btn min-h-11 self-start rounded-full border border-[var(--sf-line)] px-5 text-p-3 font-bold text-[var(--sf-ink)] disabled:opacity-35"
    >
      {label}
    </button>
  );
}

export function SaveCancel({
  onSave,
  onCancel,
  saving,
  error,
}: {
  onSave: () => void;
  onCancel: () => void;
  saving: boolean;
  error: string | null;
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          className="mm-btn min-h-11 px-2 text-p-3 font-semibold text-[var(--sf-mut)] disabled:opacity-35"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onSave}
          disabled={saving}
          className="mm-btn min-h-11 rounded-full bg-[var(--sf-ink)] px-5 text-p-3 font-bold text-[var(--sf-page)] disabled:opacity-35"
        >
          {saving ? 'Saving' : 'Save'}
        </button>
      </div>
      {error && (
        <span role="status" className="sf-note text-error">
          {error}
        </span>
      )}
    </div>
  );
}
